import { createSlice } from "@reduxjs/toolkit";
const initialStateValue = false;

export const adminRole = createSlice({
    name: "adminRole",
    initialState
        : {
        value: initialStateValue,
    },
    reducers: {
        setAdminRoleReducer: (state, action) => {
            state.value = action.payload;
        },
        clearAdminRoleReducer: (state) => {
            state.value = initialStateValue;
        },
    },
});

export const { setAdminRoleReducer, clearAdminRoleReducer } = adminRole.actions;

export default adminRole.reducer;